
	import { defineComponent } from 'vue';
	import { IonIcon, modalController } from '@ionic/vue';
	import { useI18n } from 'vue-i18n';
	import { pieChartOutline, hardwareChipOutline, cartOutline, mapOutline, videocamOutline, personOutline, ticketOutline, documentTextOutline, statsChartOutline, cashOutline, calendarOutline, notificationsOutline, cogOutline } from 'ionicons/icons';
	import PosModal from '@/components/PosModal.vue'
	export default defineComponent({
		name: 'SideMenu',
		components: { IonIcon },
		setup() {
			const { t } = useI18n({
				inheritLocale: true,
				useScope: 'global'
			});
			const openPOS = async () => {
				const modal = await modalController.create({
					component: PosModal,
					cssClass: 'my-custom-class',
					componentProps: {
						transaction: null
					}
				});
				return modal.present();
			};
			return {
				pieChartOutline,
				hardwareChipOutline,
				mapOutline,
				cartOutline,
				videocamOutline,
				personOutline,
				ticketOutline,
				documentTextOutline,
				statsChartOutline,
				cashOutline,
				calendarOutline,
				notificationsOutline,
				cogOutline,
				t,
				openPOS
			}
		},
		methods: {
		},
		computed: {
			currentUser()
			{
				//@ts-ignore
				return this.$store.state.auth.user;
			},
			can_view_cameras()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_cameras');
			},
			can_view_nvr()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_nvr');
			},
			can_view_camera_events()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_camera_events');
			},
			can_view_devices()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_devices');
			},
			can_view_customers()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_customers');
			},
			can_view_guests()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_guests');
			},
			can_view_entries()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_entries');
			},
			can_view_transactions()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_transactions');
			},
			can_view_reports()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_reports');
			},
			can_view_events()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_events');
			},
			can_view_alerts()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_alerts');
			},
			can_view_configs()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_edit_general_configs') ||
				//@ts-ignore
					this.$root.hasPermission('can_view_users') ||
					//@ts-ignore
					this.$root.hasPermission('can_view_roles') ||
					//@ts-ignore
					this.$root.hasPermission('can_view_zones') ||
					//@ts-ignore
					this.$root.hasPermission('can_view_pricings') ||
					//@ts-ignore
					this.$root.hasPermission('can_view_tags') ||
					//@ts-ignore
					this.$root.hasPermission('can_edit_alerts_configs') ||
					//@ts-ignore
					this.$root.hasPermission('can_edit_mail_configs') ||
					//@ts-ignore
					this.$root.hasPermission('can_edit_ldap_configs');
			}
		}
	});
